import SelectInput from 'components/generics/fields/SelectInput';
import classes from './index.module.scss';
import TextField from 'components/generics/fields/TextField';
import Button from 'components/generics/buttons/Button';
import { useEffect, useState } from 'react';
import { UploadPhotoInput } from '../CustomFileInput';
import EmailInput from 'components/generics/inputs/EmailInput';
import PhoneInput from 'components/generics/inputs/PhoneInput';
import { useLandaApiAxios } from 'hooks/api/axios/landa_api';
import Typography from 'components/generics/texts/Typography';
import { isEmailValid, isPhoneValid } from 'utils/validators';

const appliancesOptions = [
  {
    label: 'Pest Control',
    value: 0,
  },
  { label: 'Plumbing', value: 1 },
  { label: 'HV/AC', value: 2 },
  { label: 'Electricity', value: 3 },
  { label: 'Flooring', value: 4 },
  { label: 'Appliance', value: 5 },
  { label: 'Roof', value: 6 },
  { label: 'Windows', value: 7 },
  { label: 'Door/Locks', value: 8 },
  { label: 'Emergency', value: 9 },
  { label: 'Other', value: 10 },
];

const FormComponent = () => {
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [files, setFiles] = useState({
    firstFile: null,
    secondFile: null,
    thirdFile: null,
  });
  const [fields, setFields] = useState<any>({
    propertyAddress: '',
    subject: '',
    description: '',
    phoneNumber: '',
    email: '',
    appliances: [],
  });

  const [request] = useLandaApiAxios({
    url: '/v2/property_maintenances',
    method: 'POST',
    headers: {
      'Content-Type': 'application/vnd.api+json',
    },
  });

  const [uploadRequest] = useLandaApiAxios({
    url: '/maintenance_photos',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const handleSetField = (key: string, value: string) => {
    setFields((prevState: any) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleContinue = async () => {
    try {
      setIsLoading(true);
      await request({
        data: {
          data: {
            type: 'property_maintenances',
            attributes: {
              subject: fields.subject,
              description: fields.description,
              phone: fields.phoneNumber,
              email: fields.email,
              categories: [fields?.appliances?.value],
              address: fields.propertyAddress,
            },
          },
        },
      }).then((result: any) => {
        Object.values(files).map((file: any) => {
          const formData = new FormData();
          formData.append('file', file);
          formData.append('property_maintenance_id', result?.data?.data?.id);
          uploadRequest({
            data: formData,
          });
        });
      });
      setSuccess(true);
    } catch (e) {
      setSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (
      isEmailValid(fields.email).isValid &&
      isPhoneValid(fields.phoneNumber).isValid &&
      fields.description !== '' &&
      fields.subject !== '' &&
      fields.propertyAddress !== '' &&
      fields.appliances.length !== 0
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [fields]);

  const handleUploadFile = (key: string, value: File) => {
    setFiles((prevState) => ({ ...prevState, [key]: value }));
  };

  return (
    <>
      {success ? (
        <div className={classes.successContainer}>
          <Typography className={classes.successText}>
            Thank you! Your submission has been received!
          </Typography>
        </div>
      ) : (
        <div className={classes.formContainer}>
          <TextField
            placeholder={'Property Address*'}
            value={fields.propertyAddress}
            onChange={(e) => handleSetField('propertyAddress', e.target.value)}
            className={classes.fieldInput}
            inputStyle
          />

          <TextField
            placeholder={'Subject*'}
            value={fields.subject}
            onChange={(e) => handleSetField('subject', e.target.value)}
            className={classes.fieldInput}
            inputStyle
          />
          <TextField
            placeholder={'Description*'}
            value={fields.description}
            onChange={(e) => handleSetField('description', e.target.value)}
            className={classes.fieldInput}
            inputStyle
          />
          <PhoneInput
            value={fields.phoneNumber}
            onChange={(e) => handleSetField('phoneNumber', e)}
            inputStyle={{
              color: 'black',
              borderRadius: 8,
              fontWeight: 400,
              fontSize: '16px',
            }}
            containerStyle={{
              marginBottom: 0,
            }}
          />
          <EmailInput
            name={'Email'}
            placeholder={'Email*'}
            placeholderClass={classes.emailPlaceholder}
            inputClassName={classes.emailInput}
            value={fields.email}
            noBorder={true}
            onChange={(e) => handleSetField('email', e.target.value)}
            inputStyle
          />
          <SelectInput
            options={appliancesOptions}
            placeholder="Appliances"
            onChange={(e: any) => handleSetField('appliances', e)}
            value={fields.appliances}
            styles={{
              placeholder: (styles) => ({
                ...styles,
                color: 'var(--black)',
                marginLeft: 12,
              }),
              indicatorsContainer: () => ({
                margin: 6,
              }),
              control: (styles) => ({
                ...styles,
                backgroundColor: 'transparent',
                borderRadius: 8,
                borderColor: 'black',
              }),
            }}
          />
          <div className={classes.container}>
            <UploadPhotoInput
              value={files.firstFile}
              setValue={(file) => handleUploadFile('firstFile', file)}
            />
            <UploadPhotoInput
              value={files.secondFile}
              setValue={(file) => handleUploadFile('secondFile', file)}
            />
            <UploadPhotoInput
              value={files.thirdFile}
              setValue={(file) => handleUploadFile('thirdFile', file)}
            />
          </div>
          <div className={classes.buttonContainer}>
            <Button
              className={classes.ticketButton}
              onClick={handleContinue}
              disabled={disabled}
            >
              {isLoading ? 'Please Wait... ->' : 'Open Ticket ->'}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default FormComponent;
